import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CoinbaseWallet } from "../../../../../icons/coinbaseWallet.js";
import { EOAConnectionFailed } from "../../../../../icons/EOAConnectionFailed.js";
import { MetaMask } from "../../../../../icons/metamask.js";
import { WalletConnectIcon } from "../../../../../icons/walletConnectIcon.js";
import { EOAWallets } from "../types.js";
import { walletTypeConfig } from "../connection-error.js";
import { ConnectionFailed } from "../../../../../icons/connectionFailed.js";
export const WalletIcon = ({ walletType }) => {
    const availableWallets = walletTypeConfig.map((w) => w.key);
    if (availableWallets.includes(walletType)) {
        return (_jsxs("div", { className: "relative", children: [_jsx(EOAConnectionFailed, {}), _jsxs("div", { className: "absolute top-0 left-0 w-full h-full flex items-center justify-center z-[1]", children: [walletType === EOAWallets.METAMASK && (_jsx(MetaMask, { className: "w-[35px] h-[35px]" })), walletType === EOAWallets.WALLET_CONNECT && (_jsx(WalletConnectIcon, { className: "w-[25px] h-[25px]" })), walletType === EOAWallets.COINBASE_WALLET && (_jsx(CoinbaseWallet, { className: "w-[35px] h-[35px]" }))] })] }));
    }
    // Show default connection failed Icon if wallet type is not defined
    return (_jsx("div", { className: "relative", children: _jsx(ConnectionFailed, {}) }));
};
//# sourceMappingURL=wallet-icon.js.map